import * as React from 'react';
import '../UpdateProject.css';

export interface ProjectUpdateTabsComponentProps {
  projectSection: string;
  handleClick: (value: string) => void;
}

class ProjectUpdateTabsComponent extends React.PureComponent<ProjectUpdateTabsComponentProps> {
  public render(): React.ReactNode {
    return (
      <div className="row">
        <div className="col-xs-4 padding-r-0">
          <div
            className={this.props.projectSection === 'contact' ?
              'tab edit-project-tab tab-active' : 'tab edit-project-tab'}
            onClick={() => this.props.handleClick('contact')}
          >
            <div className="icon">
              <img
                alt="Person"
                className="icon"
                src="/img/us.png"
              />
            </div>
            <div className="title">
              <h4><strong>Información de contacto</strong></h4>
            </div>
          </div>
        </div>
        <div className="col-xs-4 padding-l-r-0">
          <div
            className={this.props.projectSection === 'company' ?
              'tab edit-project-tab tab-active' : 'tab edit-project-tab tab-2'}
            onClick={() => this.props.handleClick('company')}
          >
            <div className="icon">
              <img
                style={{height: '21px', width: '20px'}}
                alt="Building"
                className="icon"
                src="/img/building-big-inactive.png"
              />
            </div>
            <div className="title">
              <h4><strong>Información de la empresa</strong></h4>
            </div>
          </div>
        </div>
        <div className="col-xs-4 padding-l-0">
          <div
            className={this.props.projectSection === 'round' ?
              'tab edit-project-tab tab-active' : 'tab edit-project-tab tab-3'}
            onClick={() => this.props.handleClick('round')}
          >
            <div className="icon">
              <img
                alt="Euro"
                className="icon"
                src="/img/small-euro.png"
              />
            </div>
            <div className="title">
              <h4><strong>Información de la ronda</strong></h4>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProjectUpdateTabsComponent;



// WEBPACK FOOTER //
// ./src/modules/project/update/partials/ProjectUpdateTabs.component.tsx